import { categoryAllowed, clearTrackingCookies } from "./cookie-consent";
export { readConsent, CONSENT_NOTICE_VERSION } from "./cookie-consent";

export const META_PIXEL_ID = "1649675456695965";

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[];
  push?: unknown;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

let regionPromise: Promise<string> | null = null;

/** Two-letter country, or "XX" when unknown. Cached for the page visit. */
export function getRegion(): Promise<string> {
  if (regionPromise) return regionPromise;
  regionPromise = (async () => {
    try {
      const ctrl = new AbortController();
      const timer = setTimeout(() => ctrl.abort(), 2000);
      const res = await fetch("/cdn-cgi/trace", { signal: ctrl.signal, cache: "no-store" });
      clearTimeout(timer);
      if (!res.ok) return "XX";
      const text = await res.text();
      const h = /^h=(.*)$/m.exec(text)?.[1]?.trim();
      if (h && h !== window.location.host) return "XX";
      const loc = /^loc=(.*)$/m.exec(text)?.[1]?.trim().toUpperCase() ?? "XX";
      return loc === "T1" ? "XX" : loc;
    } catch {
      return "XX";
    }
  })();
  return regionPromise;
}

/** Explicit opt-in in every region; geography never grants advertising permission. */
export function regionNeedsConsent(_region: string): boolean { return true; }
export function adsAllowed(_region?: string): boolean { return categoryAllowed("marketing"); }

let pixelInitialised = false;

function loadPixel(): void {
  if (pixelInitialised) {
    window.fbq?.("consent", "grant");
    return;
  }
  pixelInitialised = true;
  if (!window.fbq) {
    const n: Fbq = function (...args: unknown[]) {
      if (n.callMethod) n.callMethod.apply(n, args);
      else n.queue?.push(args);
    } as Fbq;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    window.fbq = n;
    if (!window._fbq) window._fbq = n;
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(s);
  }
  window.fbq?.("init", META_PIXEL_ID, {}, { agent: "lovable" });
  window.fbq?.("track", "PageView");
}

export function applyConsent(_region?: string): void {
  if (adsAllowed()) loadPixel();
  else {
    if (pixelInitialised) window.fbq?.("consent", "revoke");
    clearTrackingCookies("marketing");
  }
}

/** Report a completed newsletter signup. Call only after the server confirmed it. */
export async function trackNewsletterSignup(): Promise<void> {
  if (typeof window === "undefined") return;
  if (!adsAllowed()) return;
  loadPixel();
  const eventID = `nl-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  window.fbq?.("track", "CompleteRegistration", { content_name: "newsletter" }, { eventID });
}
